export const dynamicPagesWithFiltersTypesMap = {
  accountTypes: 'accountTypes',
  challengesGroups: 'challengesGroups',
  commonFilters: 'commonFilters',
};

export const dynamicPagesRegexRoutesWithFiltersMap = {
  [dynamicPagesWithFiltersTypesMap.accountTypes]:
    /^\/admin\/PlatformsCategory\/PlatformAccountTypeResource\/(\d+|create)$/,
  [dynamicPagesWithFiltersTypesMap.challengesGroups]:
    /^\/admin\/PropTradingCategory\/PropTradingChallengeGroupResource\/(\d+|create)$/,
  [dynamicPagesWithFiltersTypesMap.commonFilters]: /^\/admin\/FiltersCategory\/FilterConditionResource\/(\d+|create)$/,
};

export const dynamicPagesRegexUpdateRoutesWithFilters = [
  /^\/admin\/PlatformsCategory\/PlatformAccountTypeResource\/\d+$/,
  /^\/admin\/PropTradingCategory\/PropTradingChallengeGroupResource\/\d+$/,
  /^\/admin\/FiltersCategory\/FilterConditionResource\/\d+$/,
];

export const dynamicCreatePagesRoutesWithFilters = [
  '/admin/PlatformsCategory/PlatformAccountTypeResource/create',
  '/admin/PropTradingCategory/PropTradingChallengeGroupResource/create',
  '/admin/FiltersCategory/FilterConditionResource/create',
];

export const getDynamicPagesFiltersFunctionsMap = id => ({
  [dynamicPagesWithFiltersTypesMap.accountTypes]: `/platforms/account_type/settings/${id}/filter`,
  [dynamicPagesWithFiltersTypesMap.challengesGroups]: `/proptrading/challenge_group/${id}/filter/`,
  [dynamicPagesWithFiltersTypesMap.commonFilters]: `/filters/filter_condition/${id}/filter/`,
});

export const dynamicPagesFiltersGetResourceFunctionsMap = {
  [dynamicPagesWithFiltersTypesMap.accountTypes]: '/config/resource/PlatformAccountTypeResource/resource/',
  [dynamicPagesWithFiltersTypesMap.challengesGroups]: '/config/resource/PropTradingChallengeGroupResource/resource/',
  [dynamicPagesWithFiltersTypesMap.commonFilters]: '/config/resource/FilterConditionResource/resource/',
};
